<template>
  <div class="">
    <p class="top-header">
      {{ $t("SuperAdminAccounts") }}
      <v-btn
        @click="getSuperAdmins()"
        small
        class="text-capitalize float-right"
        color="primary"
        dark
        ><v-icon class="mr-2" small>mdi-refresh</v-icon>
        {{ $t("Reload") }}</v-btn
      >
    </p>
    <hr class="mb-3" />
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <v-row>
      <v-col cols="12" sm="7">
        <v-btn
          @click="goToCreate()"
          width="200"
          small
          class="text-capitalize top-btn-driver"
          color="primary"
          dark
          v-if="hasPermissions(createBtnPerms)"
          >+ {{ $t("CreateNewAccount") }}</v-btn
        >
      </v-col>
      <v-col cols="12" sm="4"
        ><v-text-field
          @keydown.enter="getSuperAdmins()"
          v-model="qSearch"
          solo
          dense
          flat
          :label="$t('SearchAccounts') + '...'"
          :prepend-inner-icon="'mdi-account-search'"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="superAdmins"
      :options.sync="options"
      :server-items-length="totalSuperAdmins"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          small
          @click="goToSuperAdmin(item)"
          :disabled="!hasPermissions(editPencilPerms)"
        >
          mdi-pencil
        </v-icon>
      </template>
      <template slot="header">
        <tr class="hidden-sm-and-down">
          <th>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="getSuperAdmins()" v-on="on" small>
                  mdi-filter
                </v-icon>
              </template>
              <span>filter super admins</span>
            </v-tooltip>
          </th>
          <th>
            <v-text-field
              class="mt-5 worker-filter-input"
              dense
              outlined
              placeholder=" "
              label="Name"
              v-model="filterParams.name"
              @keydown.enter="getSuperAdmins()"
            ></v-text-field>
          </th>
          <th>
            <v-text-field
              class="mt-5 worker-filter-input"
              dense
              outlined
              placeholder=" "
              label="Email"
              v-model="filterParams.email"
              @keydown.enter="getSuperAdmins()"
            ></v-text-field>
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceChecker from "../../api/apiCheckerService";
import RestResourceAdmin from "../../api/apiAdminService";
export default {
  name: "SuperAdminList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      superAdmins: [],
      options: {},
      footerProps: vdataTable.footerProps,
      totalSuperAdmins: 0,
      qSearch: "",
      errorAlert: false,
      errorMsg: "",
      filterParams: {
        name: null,
        email: null,
        role: "SuAdmin"
      },
      headers: [
        {
          text: this.$t("Edit"),
          align: "start",
          sortable: false,
          width: 100,
          value: "edit"
        },
        {
          text: this.$t("Name"),
          width: 225,
          align: "start",
          sortable: false,
          value: "fullName"
        },
        { text: "Email", value: "email", sortable: false },
        { text: "Register date", value: "createdAt", sortable: false }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getSuperAdmins();
      },
      deep: true
    }
  },
  computed: {
    editPencilPerms() {
      return [Permission.EDIT_WORKER];
    },
    createBtnPerms() {
      return [Permission.ADD_WORKER];
    }
  },
  methods: {
    getSuperAdmins() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceAdmin.prototype
        .getSuperAdmins(this.getParams())
        .then(response => {
          if (response.status === ResponseStatus.OK) {
            this.totalSuperAdmins = response.data.total;
            this.superAdmins = response.data.data;
            this.superAdmins.map(checker => {
              checker.fullName = checker.name + " " + checker.lastName;
            });
          }
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToCreate() {
      this.$router.push({ name: "new_super_admin_account" });
    },
    goToSuperAdmin(superAdmin) {
      this.$router.push({
        name: "superAdminId",
        params: { id: superAdmin._id }
      });
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    }
  }
};
</script>

<style>
.worker-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.worker-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.worker-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
